__turbopack_context__.v({
  "buttonsWrapper": "ButtonsQuestion-module__wGGcPW__buttonsWrapper",
});
